import { createSlice } from '@reduxjs/toolkit'
const img1 = "/assets/images/units/badminton.jpg";
const img2 = "./assets/images/units/tabletennis.jpg";
const img3 = "/assets/images/units/lawtennis.jpg";
const img4 = "/assets/images/units/basketball.jpg";
const img5 = "/assets/images/units/gym.jpg";

const unitSlice = createSlice({
    name: 'units',
    initialState: {
      payload: [
        {
          img: img1,
          title: 'Badminton .'
        },
        {
          img: img2,
          title: 'Table Tennis '
        },
        {
            img: img3,
            title: 'Tennis '
          },
          {
            img: img5,
            title: 'Gym '
          },
      ]
    }
    ,
    reducers: {
        units: (state, action) => {
            state.sliders = action.payload;
        }
    }
})

export const {units} = unitSlice.actions;
export default unitSlice.reducer;
